import { CSSProperties } from 'react';

const DOT_WIDTH = 11;

export function getTransform(active: number, count: number): CSSProperties {
  if (count <= 5) {
    return {};
  }

  const dotsOffset = Math.min(Math.max(active - 2, 0), count - 5);

  return {
    transform: `translateX(-${dotsOffset * DOT_WIDTH}px)`,
  };
}
